export default function createSearchData(type, { file, query }) {
  let result = new FormData();
  if (type === "file") {
    result.append("file", file);
    result.append("type", "by_file");
  }
  if (type === "query") {
    result.append("query", query);
    result.append("type", "by_query");
  }
  if (type === "by_query_with_unrecognized") {
    result.append("query", query);
    result.append("type", "by_query_with_unrecognized");
  }
  return result;
}
